import { useMutation, useQueryClient } from 'react-query';
import { unassignVisit } from '@higo/api/lib/services/examinationService';
import { toast } from 'react-toastify';
import { useDoctorPortalApiContext } from 'contexts/ApiContext';
import { DoctorQueryKey } from 'config/doctorQueryKey';
import { useIntl } from 'react-intl';

export const useUnassignDoctorVisitMutation = () => {
  const { authorizedAxios } = useDoctorPortalApiContext();
  const intl = useIntl();

  const queryClient = useQueryClient();

  return useMutation(unassignVisit(authorizedAxios), {
    onSuccess: async () => {
      toast.success(
        intl.formatMessage({
          id: 'notification.operationSuccessful',
        }),
      );

      await queryClient.invalidateQueries(DoctorQueryKey.UnassignedVisitsList);
      await queryClient.invalidateQueries(DoctorQueryKey.Visits);
      await queryClient.invalidateQueries(DoctorQueryKey.AssignedVisitsList);
    },

    onError: (error, variables, context) => {
      // call global error handler
      return queryClient
        .getDefaultOptions()
        ?.mutations?.onError?.(error, variables, context);
    },
  });
};
